<template>
   <div class="container login-component">
        <div class="d-md-flex justify-content-md-center">
            <div class="d-md-flex">
                <div class="d-flex flex-column justify-content-between">
                    <p class="heading-small">{{ $t('login_account') }}</p>
                    <router-link :to="{name: 'login'}" class="login-btn main-btn">{{ $t('login_auth') }}</router-link>
                </div>
                <div class="or grey">
                    <span>{{ $t('or') }}</span>
                </div>
                <div class="row align-items-md-end justify-content-center">
                    <div class="col-12 col-sm-auto">
                        <button :loading="loadingGoogle" @click="loginGoogle()" class="google-login-btn">
                            <span>{{ $t('continue_with') }} Google</span>
                        </button>
                    </div>
                    <div class="col-12 col-sm-auto">
                        <button :loading="loadingFacebook" @click="loginFacebook()" class="facebook-login-btn">
                            <span>{{ $t('continue_with') }} Facebook</span>
                        </button>
                    </div>
                    <div class="col-12 col-sm" v-if="['ios', 'desktop'].includes(os())">
                        <button :loading="loadingApple" @click="loginApple()" class="apple-login-btn">
                            <span>{{ $t('continue_with') }} Apple</span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="new-account">
                <p class="create-account heading-small">{{ $t('login_component_no_account')}}</p>
                <router-link :to="{name: 'new-account'}" class="register-link heading-small">{{ $t('new_account_title') }}</router-link>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import auth3rdp from '../mixins/auth3rdp.js'
import Username from './../snippets/Username.vue'
export default {
    name: 'LoginComponentHomePage',
    props: {
        hideSocials: {
            type: Boolean,
            default: false
        }
    },
    mixins: [
        auth3rdp
    ],
    components: {
        Username
    },
    data: function() {
        return {
            username: '',
            password: '',
            errorMsgs: {
                username: '',
                password: '',
            },
            usernames: [],
            usernameChoosen: false,
            loading: false,
            loadingGoogle: false,
            loadingFacebook: false
        }
    },
    methods: {
        ...mapActions('vehicles', [
            'getVehicles'
        ]),
        ...mapActions('auth', [
            'doLogin',
            'doGetUsersForEmail'
        ]),
        updateUsername(event) {
            this.username = event.value;
        },
        async login() {
            var ok = true;
            this.loading = true;
            if(!this.username) {
                ok = false;
                this.errorMsgs.username = this.$t('mandatory');
            }
            if(!this.password) {
                ok = false;
                this.errorMsgs.password = this.$t('mandatory');
            }
            if (ok) {
                try {
                    let response = await this.doLogin({username: this.username, password: this.password});
                    this.redirectAfterLogin();
                }
                catch(err) {
                    this.loading = false;
                    if(err.response) {
                        this.$dialog.alert({
                            'message':  err.response.data.error,
                            'confirmButtonText': this.$t('btn_i_understand')
                        });
                    }
                }
            }
            else {
                this.loading = false;
            }
        },
    }
}
</script>

<style lang="scss" scoped>
$lightgrey: lightgrey;
$green: #59af54;

.new-account {
    margin-left: 80px;
}

.lower-bottom-margin {
    margin-bottom: 0px;
}
.access-account{
    margin: 0;
    font-weight: bold;
    font-size: 18px;
}
.or {
    padding-top: 60px;
    padding-left: 15px;
    padding-right: 15px;
}
.create-account {
    margin: 0;
    font-weight: bold;
    font-size: 18px;
}
.register-link {
    min-width: 200px;
    width: auto;
    padding: 8px 0;
    text-decoration: underline;
    font-size: 18px;
    display: inline-block;
    font-weight: bold;

    &:hover {
        color: #737880;
    }
}

.facebook-login-btn {
    span {
        margin-left: 10px;
    }

    @media screen and (min-width: 767px) {
        padding: 11px 15px;
    }
}

.google-login-btn {
    margin-top: 13px;

    @media screen and (max-width: 767px) {
        margin-bottom: 20px;
    }

    span {
        margin-left: 10px;
    }

    @media screen and (min-width: 767px) {
        padding: 11px 15px;
    }
}

.apple-login-btn {
    margin-top: 20px;

    span {
        margin-left: 10px;
    }

    @media screen and (min-width: 767px) {
        padding: 11px 15px;
    }
}


.create-account  {
    margin-bottom: 25px;
}

@media only screen and (max-width: 768px) {

    .login-component {
        margin-top: 80px;
        padding: 0px;
    }

    .new-account {
        margin-top: 72px;

        .create-account {
            margin-bottom: 15px;
        }

        .register-link {
            padding: 0px;
        }
    }

    .or {
        padding: 0px;
        margin: 15px 0px;

        span {
            padding: 0px;
        }
    }

    .new-account {
        margin-left: 0px;
    }

    .main-btn {
        padding: 8px 15px;
        border: 1px solid;
    }
    .google-login-btn, .facebook-login-btn, .apple-login-btn {
        border: 1px solid;
    }

}
</style>
